import React from "react";
import {
  List,
  Filter,
  Datagrid,
  SimpleShowLayout,
  Show,
  RefreshButton,
  CardActions,
  TextInput,
  TextField,
  Create,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  ReferenceField,
  NumberField,
  NumberInput,
  AutocompleteInput
} from "react-admin";
import Edit from "../edit";
import { parse } from "query-string";
import { cardActionStyle } from "../card-actions";

export const SurveyDimensionFilter = props => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
  </Filter>
);
export const SurveyDimensionList = props => (
  <List filters={<SurveyDimensionFilter />} {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="archetype" />
      <TextField source="title" />
      <TextField source="surveyId" />
      <NumberField source="position" />
    </Datagrid>
  </List>
);
export const SurveyDimensionEdit = props => {
  const redirect = `/SurveyDimensions`;
  return (
    <Edit {...props}>
      <SimpleForm redirect={redirect}>
        <ReferenceInput label="Survey" source="surveyId" reference="surveys">
          <AutocompleteInput optionText="title" />
        </ReferenceInput>
        <TextInput source="archetype" />
        <TextInput source="title" />
        <NumberInput source="position" />
      </SimpleForm>
    </Edit>
  );
};

export const SurveyDimensionCreate = props => {
  const { survey_id: survey_id_string } = parse(props.location.search);
  const survey_id = survey_id_string ? parseInt(survey_id_string, 10) : "";
  const redirect = `/SurveyDimensions`;
  return (
    <Create {...props}>
      <SimpleForm redirect={redirect} defaultValue={{ surveyId: survey_id }}>
        <ReferenceInput source="surveyId" reference="surveys">
          <SelectInput optionText="title" />
        </ReferenceInput>
        <TextInput source="title" />
        <TextInput source="archetype" />
        <NumberInput source="position" />
      </SimpleForm>
    </Create>
  );
};
const SurveyDimensionShowActions = ({ basePath }) => (
  <CardActions style={cardActionStyle}>
    <RefreshButton />
  </CardActions>
);

export const SurveyDimensionShow = props => (
  <Show
    title="SurveyDimension view"
    {...props}
    actions={<SurveyDimensionShowActions />}
  >
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="archetype" />
      <TextField source="title" />
      <TextField source="surveyId" />
      <NumberField source="position" />
      <ReferenceField source="surveyId" reference="surveys">
        <TextField source="id" />
      </ReferenceField>
      <TextField source="__typename" />
    </SimpleShowLayout>
  </Show>
);
